export default {
    common: {
        confirm: 'Confrim',
        cancel: 'Cancel',
        search: 'Search',
        submit: 'Submit',
        other: 'Other',
        default: 'DEFAULT',
        color_tag: 'COLOR TAG',
        option: 'Option',
        success: 'Success',
        error: 'Error',
        sending: 'Sending',
        send_success: 'Send Success',
        send_error: 'Send Failure',
        visits: 'VISITS',
        table: 'TABLE',
        'one-way-message': '1-way SMS',
        'two-way-message': '2-way SMS',
        'one-way-voice': '1-way Voice',
        'two-way-voice': '2-way Voice',
        broadcast: 'Broadcast',
        delete: 'Delete',
        delete_tip: 'Are you sure to delete?',
        phone_number: 'Phone Number',
        name: 'Name',
    },
    setting: {
        setting: 'Setting',
        general: 'General',
        account: 'Account',
        about: 'About',
        custom_language_label: 'Custom Language',
        logo_label: 'Restaurant Logo',
        name_label: 'Restaurant Name',
        version_label: 'Version',
        privacy_label: 'Privacy Statement',
        terms_label: 'Terms of Service',
        logout_btn: 'Logout',
        logout_tip: 'Logout current user?'
    },
    rewards: {
        rewards: 'Rewards',
        redeem: 'Redeem',
        used_time_label: 'Used Time',
        used: 'Used',
        sure_to_redeem: 'Sure to redeem ',
        header_tip: 'Support fuzzy query by phone number, you can use the last 4 digits of the phone number directly'
    }
};